import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowDownRight, Camera } from "lucide-react";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 + i * 0.12 } }),
};

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
};

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 160]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);

  return (
    <section id="hero" ref={ref} className="relative min-h-screen flex flex-col justify-end overflow-hidden">
      <motion.div style={{ scale, y }} className="absolute inset-0 z-0">
        <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Dressage d'un plat gastronomique" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0C] via-[#0D0D0C]/40 to-[#0D0D0C]/70" />
      </motion.div>

      <div className="relative z-10 max-w-[1400px] w-full mx-auto px-6 lg:px-10 pb-16 lg:pb-24">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="overline mb-6 flex items-center gap-3">
          <Camera className="w-3.5 h-3.5" /> Studio de photographie culinaire · Paris — 48.8566° N
        </motion.div>

        <h1 className="font-serif-d font-semibold tracking-tight leading-[0.95] text-5xl sm:text-6xl lg:text-[5.2rem]">
          {["Révéler le goût", "avant la première", "bouchée."].map((t, i) => (
            <span key={i} className="block reveal-mask">
              <motion.span custom={i} variants={line} initial="hidden" animate="show" className="block">
                {t.includes("le goût") ? (<>Révéler <span className="text-[#C88D51] italic font-cormorant">le goût</span></>) : t}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.1, duration: 0.8 }}
          className="mt-10 flex flex-col sm:flex-row gap-6 sm:items-center">
          <p className="font-sub text-[#A39E93] max-w-md text-base leading-relaxed">
            Restaurants, chefs, artisans et marques food. Une lumière gourmande, des images qui donnent faim.
          </p>
          <div className="flex gap-3">
            <button data-testid="hero-booking-cta" onClick={() => scrollTo("reservation")} className="btn-accent font-sub text-sm px-7 py-3.5 flex items-center gap-2">
              Réserver un shooting <ArrowDownRight className="w-4 h-4" />
            </button>
            <button data-testid="hero-explore-gallery-cta" onClick={() => scrollTo("portfolio")} className="btn-ghost font-sub text-sm px-7 py-3.5">
              Voir le portfolio
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
